'use client';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { useProfileStore, useEventZStore } from '@ninjacart/nc-nk-store';

export function useLocationPerm() {
  const userRoles = useProfileStore((state) => state.userRoles);
  const enableGlobalProfileTabMic = useEventZStore((state) => state.enableGlobalProfileTabMic);
  const setHasRequestedLocationPerm = useProfileStore((state) => state.setHasRequestedLocationPerm);
  
  const [locationPermission, setLocationPermission] = useState(false);
  
  const requestLocationPermission = async () => {
    // Prevent running on server
    if (typeof window === 'undefined') {
      return false;
    }

    if (Platform.OS === 'web') {
      // Handle web differently
      return true;
    }

    try {
      // Dynamically import expo-location only on client
      const Location = await import('expo-location');
      const { status } = await Location.requestForegroundPermissionsAsync();
      const hasPermission = status === 'granted';
      setLocationPermission(hasPermission);
      setHasRequestedLocationPerm(true);
      
      return hasPermission;
    } catch (error) {
      console.error('Error requesting location permission:', error);
      return false;
    }
  };
  
  return {
    userRoles,
    enableGlobalProfileTabMic,
    locationPermission,
    requestLocationPermission,
  };
}